import React from "react"
import PropTypes from 'prop-types'
import { Box, Container, Text } from "@chakra-ui/react"
import { graphql } from "gatsby"
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
} from "@chakra-ui/react"

export function Shipping({ shipping }) {
  console.log("SHIPPING", shipping)
  const {
    destinations
  } = shipping
  return (
    <Box
      id="shipping"
    >
      { shipping.shippingBlockDetail && 
      <Text variant={'detail'}
          dangerouslySetInnerHTML={{ __html: `<div> ${shipping.shippingBlockDetail} </div>` }}>
      </Text>
      }
      <Table size={'sm'}>
        {destinations.map((d, i) => (
          <Tbody key={`Tb${i}`}>
            <Tr key={`Key${i}`}>
              <Th ></Th>
              <Th>{d.title1}</Th>
              <Th>{d.title2}</Th>
            </Tr>
            <Tr key={`dest${i}`}>
              <Td color='brandWhite.900' paddingLeft={0}>{d.destination}</Td>
              <Td>{d.price1}</Td>
              <Td>{d.price2}</Td>
            </Tr>
          </Tbody>
        ))
        }
      </Table>

    </Box >
  )
}

Shipping.propTypes = {
  shipping: PropTypes.object.isRequired
}

export const query = graphql`
  fragment ShippingData on DatoCmsShipping {
    id
    shippingBlockDetail
    destinations {
      title1
      title2
      price1
      price2
      destination
    }
  }

  fragment UpcycleShippingData on DatoCmsUpcycleshipping {
    id
    shippingBlockDetail
    destinations {
      title1
      title2
      price1
      price2
      destination
    }
  }
`
